import * as React from "react";
const SvgFullScreen = (props) => /* @__PURE__ */ React.createElement("svg", { width: 36, height: 36, viewBox: "0 0 36 36", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("foreignObject", { x: -7.2, y: -7.2, width: 50.4, height: 50.4 }, /* @__PURE__ */ React.createElement("div", { xmlns: "http://www.w3.org/1999/xhtml", style: {
  backdropFilter: "blur(3.6px)",
  clipPath: "url(#bgblur_0_1630_2750_clip_path)",
  height: "100%",
  width: "100%"
} })), /* @__PURE__ */ React.createElement("g", { "data-figma-bg-blur-radius": 7.2 }, /* @__PURE__ */ React.createElement("rect", { width: 36, height: 36, rx: 18, fill: "#1A1A1A", style: {
  fill: "#1A1A1A",
  fill: "color(display-p3 0.1020 0.1020 0.1020)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M12.9274 16.0144V12.9262H16.0156", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeWidth: 1.76471, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M12.9274 19.9841V23.0724H16.0156", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeWidth: 1.76471, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M23.0726 16.0144V12.9262H19.9844", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeWidth: 1.76471, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M23.0726 19.9841V23.0724H19.9844", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeWidth: 1.76471, strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "bgblur_0_1630_2750_clip_path", transform: "translate(7.2 7.2)" }, /* @__PURE__ */ React.createElement("rect", { width: 36, height: 36, rx: 18 }))));
export default SvgFullScreen;
